import React from 'react';
import { usePermissionContext } from './permission-provider';
import { useAccountStore, useAuthStore } from 'store';
import { AccountType } from 'dto/access-management/account-dto';
import { ComponentType } from 'dto/raptor-component.dto';

const useRaptorComponentPermissionContext = () => {
    const { hasPermission, runHandler } = usePermissionContext();
    const accountStore = useAccountStore();
    const { currentUser } = useAuthStore();
    const { canModify, canModifyComponent } = React.useMemo(() => {
        const canModify = hasPermission('Components Modify');
        return {
            canModify,
            canModifyComponent: <T extends { type: ComponentType; accountUuid: string }>(component: T) => {
                if (!canModify) {
                    return false;
                }
                const isDPUUser = currentUser.accountType === AccountType.DPU;
                // Catapult components can only be modified by DPU users.
                if (component.type === ComponentType.CATAPULT) {
                    return isDPUUser;
                }
                // In case of the component is not created through ALM, we allow DPU users to delete it. Otherwise, check if the user has access to the account where the component was created.
                if (isDPUUser) {
                    return true;
                }
                return !!accountStore.getAccountByUuid(component.accountUuid);
            },
        };
    }, [hasPermission, accountStore.displayAccounts, currentUser.accountType]);

    return {
        hasPermission,
        canModify,
        canModifyComponent,
        runHandler,
    };
};
export { useRaptorComponentPermissionContext };
